import React from "react";
import { FaFolderOpen } from "react-icons/fa6";

export default function EmptyState({ title, text }) {
  return (
    <div className="text-center text-secondary bg-body border rounded-3 p-5">
      <FaFolderOpen size={36} className="mb-3" />
      <h3 className="h6 mb-1">{title}</h3>
      {text && <p className="small mb-0">{text}</p>}
    </div>
  );
}
